/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { TabButton } from 'components';
import './style.scss';

function TabButtonRow({
  tabs = [],
  onTabClick = () => {},
  className = '',
  activeTab = '',
  style = {},
  hideTabInMobileview = null,
}) {
  return (
    <div className={` tv-tab_button_row__container ${className}`} style={style}>
      {tabs.map(tab => (
        <TabButton
          aria-label={tab.label}
          key={`${tab.name}-tabs`}
          label={tab.label}
          className={`${
            hideTabInMobileview && hideTabInMobileview.name === tab.name
              ? 'tv-mobile--hide'
              : ''
          } ${tab.className}`}
          disabled={activeTab !== tab.name}
          onClick={() => onTabClick(tab)}
        />
      ))}
    </div>
  );
}

TabButtonRow.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  activeTab: PropTypes.string,
  onTabClick: PropTypes.func,
  style: PropTypes.shape({}),
  hideTabInMobileview: PropTypes.shape({
    name: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default TabButtonRow;
